// deps
import React, { memo, useMemo } from "react";
import cx from "classnames";

// internal deps
import { ScreenReaderOnly } from "@swiggy-private/core-ui";

// components
import BenefitItem from "./BenefitItem";

// interfaces
import { OneBenefit } from "@super-ui/interfaces/SwiggyOne";

// constants
import { ACCESSIBLITY_TEXTS } from "@super-ui/constants/SwiggyOne";
import { ONE_WIDGET_TEST_IDS } from "@super-ui/test-ids/one-widget";

// helpers
import { getPrefixedTestId } from "@super-ui/helpers/String";

import styles from "../styles/Benefits.v4.scss";

interface BenefitListProps {
    benefits: OneBenefit[];
    testIdPrefix?: string;
    isOneLitePlan?: boolean;
}

const BenefitList: React.FC<BenefitListProps> = ({
    benefits,
    testIdPrefix,
    isOneLitePlan = false,
}: BenefitListProps) => {
    const accessibilityText = useMemo(() => {
        let text = ACCESSIBLITY_TEXTS.PLAN_BENEFITS;
        benefits.forEach(benefit => {
            text += `${benefit.title} ${benefit.sub_title}. `;
        });
        return text;
    }, [benefits]);

    const benefitsTestId = useMemo(() => getPrefixedTestId(ONE_WIDGET_TEST_IDS.BENEFITS, testIdPrefix), [testIdPrefix]);

    const benefitContainerClass = cx({
        [styles.benefitContainer]: true,
        [styles.benefitContainerLite]: isOneLitePlan,
    });

    if (benefits.length === 0) {
        return null;
    }

    return (
        <div className={benefitContainerClass} data-testid={benefitsTestId}>
            <ScreenReaderOnly text={accessibilityText} />
            <ul>
                {benefits.map((benefit, idx) => (
                    <BenefitItem benefit={benefit} key={idx} isOneLitePlan={isOneLitePlan} idx={idx} />
                ))}
            </ul>
        </div>
    );
};

export default memo(BenefitList);
